import React, { FunctionComponent } from 'react';
import { DisplayStars } from '@/components/responsive/product/seller/DisplayStars';
import { Chevron } from '@/components/responsive/product/icons/Chevron';
import { MkpSeller } from "@/models/scope/productSheet/mkpSeller/MkpSeller";
import { LAYER_TYPE, MAX_RATING } from '@/utils/constants';
import Utils from '@/libs/Utils';
import theme from '@/utils/theme';
import {
    dispatchProductSheetSellerNameHandleClick,
    dispatchServicesSellersPartnersHandleClick
} from "@/animations/responsive/productPageTracking";

interface Props {
    sellerMKP: MkpSeller,
    setLayerType: (layerType: string, sellerData: undefined | MkpSeller) => void,
    isLayer: boolean;
    setShowCloseLayerButton: (status: boolean) => void;
    isWinningOffer?: boolean;
}

const LIMIT_COUNT = 1000;
const LIMIT_NEW_SELLER = 2;

const getCountValue = (count: number): string => {
    if (count === 1) {
        return ` ${count} vente`;
    }
    if (count <= LIMIT_COUNT) {
        return ` ${count} ventes`;
    }

    return ` + de ${LIMIT_COUNT} ventes`;
};

export const MKPSeller: FunctionComponent<Props> = ({ sellerMKP, setLayerType, isLayer, setShowCloseLayerButton, isWinningOffer = false }) => {
    const isNewSeller = !sellerMKP.isPremium && sellerMKP.ordersCount <= LIMIT_NEW_SELLER;

    const handleClick = () => {
        setShowCloseLayerButton(!isWinningOffer);
        setLayerType(LAYER_TYPE.SELLER_SERVICE, sellerMKP);
        dispatchServicesSellersPartnersHandleClick()
    };
    const renderSellerName = () => {
        return (
            <div className='seller-label'>
                <p>
                    {(!!sellerMKP.isPremium || isNewSeller) && (
                        <a className='top-seller' href={sellerMKP.sheetUrl} target='_blank'>
                            {`${sellerMKP.isPremium ? 'Top vendeur' : 'Nouveau vendeur'}`}
                        </a>
                    )}
                    <a className='sell-by' href={sellerMKP.sheetUrl} target='_blank'> Vendu et expédié par {' '}
                        <a
                            className='link'
                            onClick={() => {
                                window.open(
                                    `${sellerMKP?.sheetUrl}`,
                                    '_blank',
                                    'noopener,noreferrer',
                                );
                                dispatchProductSheetSellerNameHandleClick(`Clic nom vendeur FP ${sellerMKP?.shopName}`)
                            }}
                        >
                            <span className='seller-name'>{`${sellerMKP?.shopName} `}</span>
                        </a>
                    </a>
                </p>
            </div>
        );
    };
    const renderSellerRating = () => {
        const grade = sellerMKP.grade !== 0 ? Utils.getDecimalFormat(sellerMKP.grade) : "0";
        return (
            <div className='rating-mkp'>
                <DisplayStars score={String(grade)} color={theme.gray900} />
                <p>
                    {`${grade}/${MAX_RATING} ${getCountValue(sellerMKP.ordersCount)}`}
                </p>
            </div>
        );
    };
    const renderSellerService = () => {
        return (
            <div className='partner-services' onClick={handleClick}>
                <p>Services vendeur partenaire</p>
                {isLayer ? (
                    <div className='chevron'>
                        <Chevron />
                    </div>
                ) : (
                    <img src={'/assets/images/responsive/icons/info.svg'} alt='accès service vendeur partenaires' />
                )}
            </div>
        );
    };

    return (
        <div>
            {renderSellerName()}
            {renderSellerRating()}
            {renderSellerService()}
        </div>
    );
};
